import { useMutation, useQueryClient } from '@tanstack/react-query';

import { MONTHLY_INCOME_QUERY_KEY } from '@/queries/monthlyIncome';

import { HttpClient } from '@/network/HttpClient';

export type RecalculateMonthlyIncomeParams = {
  url: string;
  year_month: string;
};

export const useRecalculateMonthlyIncomeMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: RecalculateMonthlyIncomeParams) =>
      HttpClient.request<{ flash_message?: string; flash_type?: string }>({
        method: 'POST',
        url: params.url,
        data: {
          year_month: params.year_month,
        },
      }),
    onSuccess: () => {
      // Invalidate monthly income query to refresh data
      queryClient.invalidateQueries({
        queryKey: [MONTHLY_INCOME_QUERY_KEY],
      });
    },
  });
};
